<a (click)="linkClick(productData?.Link)" role="button" class="prod-status" *ngIf="productData">
    <div class="prod-img-wrapper" *ngIf="productData?.Image">
        <img [src]="imageUrl+productData.Image" alt="Announcements Image">
    </div>
    <h4 class="prod-status-text sec-heading3" *ngIf="productData?.Title">{{productData.Title}}</h4>
</a>